var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { User } from '../../../models/user';
import { CommonConstant } from '../../app.constants';
import { FilterSearch } from '../../../models/filter-search';
import { AuthService } from '../../core/auth.service';
import { UserService } from '../../services/user.service';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { DiscoverService } from '../../services/discover/discover.service';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
var InfluencerHomeComponent = /** @class */ (function (_super) {
    __extends(InfluencerHomeComponent, _super);
    function InfluencerHomeComponent(auth, userService, influencerService, discoverService, placeholderService, dashboardService, modalService) {
        var _this = _super.call(this, userService) || this;
        _this.auth = auth;
        _this.userService = userService;
        _this.influencerService = influencerService;
        _this.discoverService = discoverService;
        _this.placeholderService = placeholderService;
        _this.dashboardService = dashboardService;
        _this.modalService = modalService;
        _this.scrollDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE;
        _this.throttle = CommonConstant.DEFAULT_INFINITE_SCROLL_THROTTLE_100;
        _this.currentFilterSearch = new FilterSearch();
        _this.dashboardPosts = [];
        _this.influencerGroupId = 0;
        _this.user = new User();
        _this.currentFilterSearch.orderBy = 'latest';
        return _this;
    }
    InfluencerHomeComponent.prototype.ngOnInit = function () {
        if (this.auth.isAuth()) {
            this.user = this.auth.getUser();
        }
        this.currentInfluencer = this.userService.getInfluencerInfo();
        // intialize search criteria
        this.currentFilterSearch = new FilterSearch();
        this.currentFilterSearch.limit = 50;
        this.currentFilterSearch.offset = 0;
        this.currentFilterSearch.orderBy = 'latest';
        this.currentFilterSearch.period = 60;
        // fetch data
        this.loadInfluencerKpi();
        this.fetchListChannel();
        this.fetchRecentMessages();
    };
    InfluencerHomeComponent.prototype.companyChangeCallback = function (companyId) {
    };
    InfluencerHomeComponent.prototype.fetchListChannel = function () {
        var _this = this;
        if (this.currentInfluencer) {
            this.influencerService.loadListChannelOfInfluencer(this.currentInfluencer.id).subscribe(function (res) {
                _this.socialFilterOptions = res.map(function (c) { return ({
                    id: c.id,
                    handle: c.handle,
                    name: c.platform ? c.platform.name + "(" + c.handle + ")" : null,
                    platformId: c.platform ? c.platform.id : null,
                }); });
                if (_this.socialFilterOptions.length > 0) {
                    _this.currentSocialFilter = _this.socialFilterOptions[0];
                    var _a = _this.currentSocialFilter, handle = _a.handle, platformId = _a.platformId;
                    _this.getPostByHandleAndPlatform(handle, platformId, false);
                }
            });
        }
    };
    InfluencerHomeComponent.prototype.loadInfluencerKpi = function () {
        var _this = this;
        this.influencerService.getInfluencer(this.currentInfluencer.id).subscribe(function (res) {
            _this.dashboardKPIData = _this.influencerService.influencerDetails.globalKpi;
        });
    };
    InfluencerHomeComponent.prototype.onScrollDown = function () {
        var _a = this.currentInfluencer, handle = _a.handle, platformId = _a.platformId;
        this.getPostByHandleAndPlatform(handle, platformId, true);
    };
    InfluencerHomeComponent.prototype.onChangeChannel = function (e) {
        if (e) {
            var handle = e.handle, platformId = e.platformId;
            this.getPostByHandleAndPlatform(handle, platformId, false);
        }
    };
    InfluencerHomeComponent.prototype.eventOrderList = function (orderField) {
        if (this.currentFilterSearch &&
            !this.compareCurrentFilterWithPreviousFilter()) {
            this.currentFilterSearch.orderBy = orderField;
            this.onChangeSearchCriteria(this.currentFilterSearch);
        }
    };
    InfluencerHomeComponent.prototype.onChangeSearchCriteria = function (orderByFilter) {
        this.fetchPost(false);
    };
    InfluencerHomeComponent.prototype.editMessage = function () {
        this.editingMessages = !this.editingMessages;
    };
    InfluencerHomeComponent.prototype.compareCurrentFilterWithPreviousFilter = function () {
        return (JSON.stringify(this.currentFilterSearch) ===
            JSON.stringify(this.storedFilterSearch));
    };
    InfluencerHomeComponent.prototype.getPostByHandleAndPlatform = function (handle, platformId, isScrolling) {
        this.currentFilterSearch.mentions = ["@" + handle];
        this.currentFilterSearch.platforms = [platformId];
        this.fetchPost(isScrolling);
    };
    InfluencerHomeComponent.prototype.fetchPost = function (isScrolling) {
        var _this = this;
        if (isScrolling) {
            this.currentFilterSearch.searchAfter = this.searchAfter;
        }
        else {
            this.currentFilterSearch.searchAfter = [];
        }
        delete this.currentFilterSearch['topics'];
        delete this.currentFilterSearch['industries'];
        this.placeholderService.show(CommonConstant.DISCOVER_POST_LIST_HOLDER);
        this.discoverService.searchPosts(this.currentFilterSearch)
            .subscribe(function (res) {
            // update the total result post and pagination data
            _this.updateSearchAfter(res.lastSortValues);
            var nextResult = res.posts.filter(function (p) { return p.influencer_id === _this.currentInfluencer.id; })
                .map(function (p) { return Object.assign({}, p, {
                influencerName: _this.currentInfluencer.name || _this.user.fullName
            }); });
            if (isScrolling) {
                _this.dashboardPosts = _this.dashboardPosts.concat(nextResult);
            }
            else {
                _this.dashboardPosts = nextResult;
            }
            _this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
        }, function (err) {
            _this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
        });
    };
    InfluencerHomeComponent.prototype.updateSearchAfter = function (lastSortValues) {
        this.searchAfter = [];
        if (lastSortValues != null && lastSortValues.length > 0) {
            this.currentFilterSearch.searchAfter = lastSortValues;
        }
    };
    InfluencerHomeComponent.prototype.fetchRecentMessages = function () {
        var _this = this;
        this.dashboardService.fetchRecentMessages()
            .subscribe(function (res) {
            _this.recentMessages = res;
        });
    };
    InfluencerHomeComponent.prototype.onConfirmRemoveMessage = function (message) {
        if (!message) {
            return;
        }
        this.messageToRemove = message;
        this.modalService.open(this.confirmRemoveMessageDialog);
    };
    InfluencerHomeComponent.prototype.oncConfirmRemoveMessage = function () {
        console.log('Remove message confirmed.', this.messageToRemove); // Test code
        this.modalService.close();
        this.messageToRemove = null;
    };
    InfluencerHomeComponent.prototype.closeConfirmRemoveMessage = function () {
        this.modalService.close();
    };
    return InfluencerHomeComponent;
}(AbstractAchooComponent));
export { InfluencerHomeComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-home/influencer-home.component.ts.pre-build-optimizer.js